import classNames from 'classnames';
import { Title } from '@gje/typography/lib';
import { getText } from '../../../services/text/text-service';
import { numberWithSpaces } from '../../../utils/stringUtils';
import { resolvePaymentTerm } from '../../../services/calculation-data/calculation-data-service';
import { PrimaryButton, SecondaryButton } from '@gje/buttons';
import * as React from 'react';
import { Coverage } from '../../../types/Coverage';

interface Props {
    handleTillagsBuy: Function;
    price: number;
    paymentTerm: number;
    coverages: Coverage[];
    tillagsBought: boolean;
    handleClickAnywhere: any;
    renderTillagsInfo: Function;
    disableButton?: boolean;
    showPrice?: boolean;
}

const AdditionalCoverages: React.FC<Props> = ({
    handleTillagsBuy,
    price,
    paymentTerm,
    tillagsBought,
    coverages,
    handleClickAnywhere,
    renderTillagsInfo,
    disableButton,
    showPrice
}) => {
    return (
        <div
            className={classNames('row', 'tillags')}
            onClick={handleClickAnywhere}>
            <div className="col-sm-1-5" />
            <div className="col-sm-14 align-left">
                <Title tag="h3">
                    {getText('webshopsweden.common.tillags')}
                </Title>
                <Title tag="h4" className="margin-top-13 title-without-bold">
                    {getText('webshopsweden.common.tillagsDescription')}
                </Title>
                <ul
                    key="tillags"
                    className="margin-top-13 tillags-coverages-list">
                    {renderTillagsInfo(coverages)}
                </ul>
            </div>
            <div className="col-sm-6 align-right">
                <div className="row text-center margin-top-13">
                    {showPrice ? (
                        <Title tag="h3">
                            {`${numberWithSpaces(price)} ${resolvePaymentTerm(
                                paymentTerm,
                                price
                            )}`}
                        </Title>
                    ) : (
                        <Title tag="h3" className={'height-42'} />
                    )}
                </div>
                {tillagsBought ? (
                    <div className="row margin-top-39 flex-justify-center">
                        <SecondaryButton onClick={e => handleTillagsBuy(e)}>
                            <Title
                                tag={'h5'}
                                children={getText(
                                    'webshopsweden.common.buyingInformation.remove'
                                )}
                            />
                        </SecondaryButton>
                    </div>
                ) : (
                    <div className="row margin-top-39">
                        <PrimaryButton
                            borderColor={'red'}
                            flexible={true}
                            disabled={disableButton}
                            onClick={e => handleTillagsBuy(e)}
                            className={classNames('position-absolute-left')}>
                            <Title
                                tag={'h4'}
                                children={getText(
                                    'webshopsweden.common.cardButton'
                                )}
                            />
                        </PrimaryButton>
                    </div>
                )}
            </div>
            <div className="col-sm-1-5" />
        </div>
    );
};

export default AdditionalCoverages;
